<template>
  <div v-loading.fullscreen.lock="loading" class="main_center clearfix">
    <el-form ref="form" :model="form" :rules='rules' label-width="140px" class="form">
      <div class="right-content">
        <el-card class="box-card" >
          <div slot="header" class="clearfix">
            <span>配置信息</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="业务类型：" prop='busType'>
                <el-select v-model="form.busType" value-key="value" style="width:100%;"
                           @change="selectBusTypeClick">
                  <el-option v-for="(item,index) in businessTypeNamelist" :key="index"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="节点分类：" prop='classNode' style="width:100%;">
                <el-input v-model="form.classNode" maxlength="20" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.busType == 'CG'">
              <el-form-item label="采购方式：" prop='purchaserMode' >
                <el-select v-model="form.purchaserMode" multiple value-key="value" style="width:100%;"
                           @change="selectpurchaserModeClick">
                  <el-option v-for="(item,index) in purchaserModeList" :key="index"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="节点编号：" prop='nodeCode' style="width:100%;">
                <el-input v-model="form.nodeCode" maxlength="30" show-word-limit disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="节点名称：" prop='nodeName' style="width:100%;">
                <el-input v-model="form.nodeName" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="数据集编码：" prop='datasetCode' style="width:100%;">
                <el-input v-model="form.datasetCode" maxlength="200" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序：" prop='sort' style="width:100%;">
                <el-input v-model="form.sort"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="分组标签：" prop='groupMark' style="width:100%;">
                <el-select v-model="form.groupMark" >
                  <el-option label="项目" :value="1"></el-option>
                  <el-option label="标段" :value="2"></el-option>
                  <el-option label="多标段" :value="3"></el-option>
                  <el-option label="不关联项目标段" :value="9"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标准名称：" prop='standardName' style="width:100%;">
                <el-input v-model="form.standardName" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
         <el-row>
            <el-col :span="12">
              <el-form-item label="是否是项目监管节点：" prop='supperVisionFlag' style="width:100%;">
                <el-switch
                        v-model="form.supperVisionFlag"
                        :active-value="true"
                        :inactive-value="false"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
         </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支持自定义表单：" prop='enableCustom' style="width:100%;">
                <el-switch
                    v-model="form.enableCustom"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.enableCustom == 1">
              <el-form-item label="自定义表单：" prop='formId' style="width:100%;">
                <el-select v-model="form.formId" filterable>
                  <el-option v-for="itm in customList"
                             :value="itm.id"
                             :key="itm.id"
                             :label="itm.tit"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="需要受理：" prop='enableHandle' style="width:100%;">
                <el-switch
                        v-model="form.enableHandle"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0"
                        @change="ChangeHandle(form.enableHandle)">
                </el-switch>
                <el-badge :value="commonBadge" :hidden="form.enableHandle==0" class="commonBtn"> <el-button type="primary" :disabled="form.enableHandle==0" @click="commonBtnHandle">通用审批流配置</el-button></el-badge>
                <el-badge :value="specialBadge" class="specialBtn"><el-button type="primary" @click="specialBtnHandle">个性化审批流配置</el-button></el-badge>
                <div style="color:red;">备注：个性化配置高于“通用配置”，且不受"需要审批"状态的开关影响</div>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12"  v-if="showHandleRole">
              <el-form-item label="受理角色：" prop='handleRole' style="width:100%;">
                <el-select v-model="form.handleRole"   style="width:100%;">
                  <el-option v-for="(item,index) in sysRoleList" :key="item.id"
                             :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支持附件类别约束：" prop='categoryIsOpen' style="width:100%;">
                <el-switch
                        v-model="form.categoryIsOpen"
                        :active-value="true"
                        :inactive-value="false"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.categoryIsOpen">
              <el-form-item label="附件类别编码：" prop='categoryCode' style="width:100%;">
                <el-select v-model="form.categoryCode" >
                  <el-option v-for="itm in categoryCodeList" :value="itm.code"
                             :key="itm.code" :label="itm.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开启预警：" prop='warnEnable' style="width:100%;">
                <el-switch
                        v-model="form.warnEnable"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联视角：" style="width:100%;">
                <el-checkbox-group v-model="linkangles">
                  <el-checkbox v-for="item in parterList"
                               :label="item.value"
                               :key="item.value"
                               border
                  >{{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>

              </el-form-item>
            </el-col>
          </el-row>

        </el-card>


        <el-card class="box-card" style="margin-top:20px">
          <div slot="header" class="clearfix">
            <span>预警项信息</span>
          </div>

          <div style="position: relative;top:-10px">
            <el-button size="small" icon="el-icon-plus" type="primary" :disabled="warnItemEditDisable"
                       v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add')"
                       @click="showWarnItemWindow()">新增
            </el-button>
            <el-button size="small" icon="el-icon-delete" type="primary"
                       :disabled="warnItemEditDisable"
                       v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')"
                       @click="deleteSelectItem()">删除
            </el-button>
          </div>
          <el-table :data="tableData" ref="multipleTable" stripe border
                    @selection-change="handleSelectionChange">
            <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column fixed type="selection" align="center"
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column fixed label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button type="text" title="修改" :disabled="warnItemEditDisable" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add')" @click="updateWarnItem(scope.row)">修改</el-button>
                <el-button type="text" title="删除" :disabled="warnItemEditDisable" v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_delete')"
                           @click="deleteById(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>


            <el-table-column label="预警项名称" prop='itemName' header-align="center" align="left"
                             min-width='150'
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column label="预警项编号" prop='itemCode' header-align="center" align="left"
                             min-width='150'
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column label="通知角色id集合" prop='notifyRole' header-align="center" align="left"
                             min-width='150'
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column label="状态" prop='openEnable' header-align="center" align="center"
                             min-width='60'
                             :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <el-tag size="small" :hit="false" effect="plain">
                  {{ scope.row.openEnable == 0 ? "关闭" : "开启" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="预警内容" prop='warnContent' header-align="center" align="center"
                             min-width='120'
                             :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column label="预警类型" prop='warnTypeName' header-align="center" align="center"
                             min-width='100'
                             :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <el-tag size="small" :hit="false" effect="plain"> {{ scope.row.warnTypeName }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="普通预警" header-align="center" align="center" min-width='100'
                             :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <el-tag size="small" :hit="false" effect="plain"> {{ scope.row.genComporName }}</el-tag>
                {{ scope.row.genLimit }} {{ scope.row.genUnitName }}
              </template>

            </el-table-column>
            <el-table-column label="严重预警" header-align="center" align="center" min-width='100'
                             :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <el-tag size="small" :hit="false" effect="plain"> {{ scope.row.seriComporName }}
                </el-tag>
                {{ scope.row.seriLimit }} {{ scope.row.seriUnitName }}
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination background
                         layout="sizes, prev, pager, next"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="pageSize"
                         :total="total"
                         :current-page="pageIndex"
                         @size-change="sizeChangeHandle"
                         @current-change="currentChangeHandle"></el-pagination> -->

        <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
        </pagination>  
        </el-card>

      </div>
      <div class="left-content">
        <div class="left-navbar">
          <!--                    <right-nav :childData='listNav'></right-nav>  -->
          <el-button type="primary" size="small" plain style="margin-right:10px;" @click="save()">保存
          </el-button>
          <el-button size="small" @click="backBtn">返回</el-button>
        </div>
      </div>
    </el-form>

    <el-dialog  :title="warnItemForm.id!=''?'修改预警配置项':'新增预警配置项'" :visible.sync="dialogVisible" width="80%">
      <div class="dialogBox">
        <el-form ref="warnItemForm"
                 :model="warnItemForm"
                 :rules='warnrules'
                 label-width="140px"
                 class="form">
          <el-row>
            <el-col :span="12" style="display: none;">
              <el-form-item label="id：" prop='id' style="width:100%;">
                <el-input
                        v-model="warnItemForm.id" show-word-limit disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--                  <el-form-item label="预警项名称：" prop='itemName' style="width:100%;">
                                  <el-input v-model="warnItemForm.itemName" maxlength="50"
                                            show-word-limit></el-input>
                                </el-form-item>-->

              <el-form-item label="预警项：" prop='itemName' style="width:100%;">
                <select-prj-page
                        :value.sync="warnItemForm.itemName"
                        :valueKey="'name'"
                        :labelKey="'itemName'"
                        :columns="itemColumns"
                        :dataList="itemList"
                        @doSearchMethod="setItemList"
                        @onSelect="onSelectItemData"
                ></select-prj-page>
              </el-form-item>
            </el-col>
            <!--                <el-col :span="12">
                              <el-form-item label="预警项编号：" prop='itemCode' style="width:100%;">
                                <el-input v-model="warnItemForm.itemCode" maxlength="20"
                                          show-word-limit></el-input>
                              </el-form-item>
                            </el-col>-->
          </el-row>
          <el-row>
            <!--                <el-col :span="12">
                              <el-form-item label="预警类型：" prop='warnType'>
                                <el-select v-model="warnItemForm.warnType" value-key="value"
                                           style="width:100%;"
                                           @change="selectWarnTypeClick($event)">
                                  <el-option v-for="(item,index) in warnTypeNamelist" :key="item.value"
                                             :label="item.name"
                                             :value="item.value"></el-option>
                                </el-select>

                              </el-form-item>
                            </el-col>-->

            <el-col :span="24" style="position:relative;">
              <el-form-item label="预警类型：" props="warnType">
                <el-cascader
                        style="width: 100%"
                        ref="cascaderSelectRef"
                        v-model="warnItemForm.warnType"
                        :props="props"
                        :options="options"
                        filterable
                        clearable>
                  <template slot-scope="{ node, data }">
                    <span :title="data.label">{{ data.label }}</span>
                  </template>
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否必须开启：" prop="mustOpen">
                <el-switch
                        v-model="warnItemForm.mustOpen"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否开启：" prop="openEnable">
                <el-switch
                        v-model="warnItemForm.openEnable"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="预警内容：" prop='warnContent' style="width:100%;">
                <el-input v-model="warnItemForm.warnContent" maxlength="2000"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="排序：" prop='sort' style="width:100%;">
                <el-input v-model="warnItemForm.sort"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="通知角色：" prop='notifyRole' style="width:100%;">
                <el-select v-model="roleList" style="width:100%;" placeholder="多选框" multiple>
                  <el-option v-for="(item) in sysRoleList" :key="item.id"
                             :label="item.name"
                             :value="item.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
          </el-row>
          <el-row >
            <el-col :span="6">
              <el-form-item label="普通级别比较符：" prop='genCompor' style="width:100%;">
                <el-select v-model="warnItemForm.genCompor" value-key="value"
                           style="width:100%;"
                >
                  <el-option v-for="(item,index) in warnComporNamelist" :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="普通级别阈值：" prop='genLimit' style="width:100%;">
                <el-input v-model="warnItemForm.genLimit"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--                  <el-form-item label="普通级别单位：" prop='genUnit' style="width:100%;">
                                  <el-input v-model="warnItemForm.genUnit" maxlength="4"
                                            show-word-limit></el-input>
                                </el-form-item>-->
              <el-form-item label="普通级别单位：" prop='genUnit' style="width:100%;">
                <el-select v-model="warnItemForm.genUnit" value-key="value"
                           style="width:100%;"
                >
                  <el-option v-for="(item,index) in WarnUnitNamelist" :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否启用：" prop='genUnit' style="width:100%;">
                <el-switch
                        v-model="warnItemForm.genIsOpen"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="6">
              <el-form-item label="严重级别比较符：" prop='seriCompor' style="width:100%;">
                <el-select v-model="warnItemForm.seriCompor" value-key="value"
                           style="width:100%;"
                >
                  <el-option v-for="(item,index) in warnComporNamelist" :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="严重级别阈值：" prop='seriLimit' style="width:100%;">
                <el-input v-model="warnItemForm.seriLimit"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--                  <el-form-item label="严重级别单位：" prop='seriUnit' style="width:100%;">
                                  <el-input v-model="warnItemForm.seriUnit" maxlength="4"
                                            show-word-limit></el-input>
                                </el-form-item>-->
              <el-form-item label="严重级别单位：" prop='seriUnit' style="width:100%;">
                <el-select v-model="warnItemForm.seriUnit" value-key="value"
                           style="width:100%;"
                >
                  <el-option v-for="(item,index) in WarnUnitNamelist" :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否启用：" prop='genUnit' style="width:100%;">
                <el-switch
                        v-model="warnItemForm.seriIsOpen"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="saveWarnItem" style="margin-bottom:20px;">保存</el-button>
           <el-button @click="backWarn()" class="backBtn">返回</el-button>
      </span>
    </el-dialog>

    <flowNodeDialog ref="flowNodeDialogRef" :dialogType="dialogType" :dialogFormVisible.sync="formDialogVisible" :selectOptions="sysRoleList" :flowId="form.id" :commonBadge.sync="commonBadge" :specialBadge.sync="specialBadge" :dataList.sync="sonDataList"></flowNodeDialog>
  </div>
</template>

<script>
  import selectPrjPage from '@/components/selectPage';
  import {isInteger, strLength_5, strLength_8} from '@/utils/validate';
  import {tabsCloseCurrentHandle} from '@/utils/routeTab';
  import Pagination from '@/components/Pagination.vue';
  import flowNodeDialog from "./components/flowNodeDialog";

  export default {
  components: {selectPrjPage,Pagination, flowNodeDialog},
  data() {
    return {
      showHandleRole:false,
      itemColumns: [{name: 'name', title: '预警项名称'}, {name: 'value', title: '预警项编号'}],
      itemList:[],
      cardHight: (document.documentElement.clientHeight - 116) + 'px',
      loading: false,
      businessTypeNamelist: [],
      purchaserModeList: [],
     // warnTypeNamelist: [],
      sysRoleList: [],
      warnComporNamelist: [],
      WarnUnitNamelist:[],
      WarnItemlist:[],
      canWarnAdd: false,
      form: {
        id: '',//id
        busType: '',//业务类型
        busTypeName: '',
        standardName:'',
        purchaserMode:[], // 采购方式
        purchaserModeName:'',
        warnTypeName: '',
        categoryCode:'',// 附件类型编码
        nodeName: '',//节点名称
        nodeCode: '',//节点编号
        classNode: '',//节点分类
        // classNodeName: '',
        warnEnable: 1,//开启预警
        sort: '',//排序
        datasetCode: '',//数据集编码
        formId: '',//表单id
        enableHandle: 0,  //是否受理 0否 1是
        enableCustom: 0,//是否支持自定义表单  0否 1是
        categoryIsOpen: 0,//是否支持附件类型约束  0否 1是
        groupMark:1, // 分组标签 1项目 2标段
        linkrolesVos: [],//关联视角
        handleRole:'',
        supperVisionFlag:false,// 是否是项目监管节点
      },
      rules: {
        busType: [{required: true, message: '请选择业务类型', trigger: 'change'}],
        classNode: [{required: true, message: '请输入节点分类', trigger: 'blur'}],
        purchaserMode: [{required: true, message: '请选择采购方式', trigger: 'change'}],
        formId: [{required: true, message: '请选择自定义表单', trigger: 'change'}],
        handleRole: [{required: true, message: '请选择受理角色', trigger: 'change'}],
        categoryCode: [{required: true, message: '请选择附件类别约束', trigger: 'change'}],
        nodeName: [{required: true, message: '请输入节点名称', trigger: 'blur'}, {
          validator: strLength_5,
          trigger: 'blur'
        }],
        sort: [{required: true, message: '请输入排序', trigger: 'blur'}, {
          validator: isInteger,
          trigger: 'blur'
        }],
      },
      upAddIndex: '', //判断是新增还是详情页
      saveClick: false,
      errorData: {},
      warnItemVisible: false,
      tableData: [],
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      multipleSelection: [],
      dialogVisible: false,
      warnItemForm: {
        id: '', //预警项id
        flowId: '', //节点id
        warnType: '', //预警类型
        warnTypeName: '',
        itemName: '', //预警项名称
        itemCode: '', //预警项编号
        openEnable: 1, //是否开启 0关闭 1开启
        genIsOpen: 1, //普通级别是否启用 0关闭 1开启
        seriIsOpen: 1, //严重级别是否启用 0关闭 1开启
        warnContent: '', //预警内容
        notifyRole: "", //通知角色id集合
        genCompor: '', //普通级别比较符
        genLimit: '', //普通级别阈值
        genUnit: '', //普通级别单位
        seriCompor: '', //严重级别比较符
        seriLimit: '', //严重级别阈值
        seriUnit: '', //严重级别单位
        sort: '', //排序
        mustOpen:0, // 控制预警规则是否可编辑
      },
      roleList: [],
      handleRoleList:[],
      customList: [],
      categoryCodeList:[],
      warnrules: {
        warnType: [{required: true, message: '请选择预警类型', trigger: 'blur'}],
        itemName: [{required: true, message: '请选择预警项', trigger: 'blur'}/*, {
          validator: strLength_5,
          trigger: 'blur'
        }*/],
       /* itemCode: [{required: true, message: '请输入预警项名称', trigger: 'blur'}, {
          validator: strLength_1,
          trigger: 'blur'
        }],*/
        genCompor: [{required: true, message: '请选择普通级别比较符', trigger: 'blur'}],
        genUnit: [{required: true, message: '请输入普通级别单位', trigger: 'blur'}, {
          validator: strLength_8,
          trigger: 'blur'
        }],
        seriCompor: [{required: true, message: '请选择严重级别比较符', trigger: 'blur'}],
        seriUnit: [{required: true, message: '请输入严重级别单位', trigger: 'blur'}, {
          validator: strLength_8,
          trigger: 'blur'
        }],
        sort: [{required: true, message: '请输入排序', trigger: 'blur'}, {
          validator: isInteger,
          trigger: 'blur'
        }],
        genLimit: [{
          validator: isInteger,
          trigger: 'blur'
        }],
        seriLimit: [{
          validator: isInteger,
          trigger: 'blur'
        }],
      },
      parterList: [],
      props: {
        multiple: false,
        lazy: false,
        value:'type',
        lazyLoad:this.lazyLoad,
      },
      options: [],

      dialogType:1,// 1表示默认审批流 2 表示个性化审批流
      formDialogVisible:false,
      commonBadge:null,
      specialBadge:null,
      sonDataList:[],
    }
  },
  activated() {
    this.form.id = this.$route.query.id;
    this.getDataById();
    this.getDataList();
    this.warnItemForm.flowId = this.form.id;
    this.form.id != '' ? this.canWarnAdd = true : this.canWarnAdd = false;
  },
  mounted() {
    this.getDic('jz_dgwitness_bustype');
    this.getDic('jz_dgwitness_purchaser_mode');
    this.getDic('jz_dgwitness_warn_compor');
    this.getDic('jz_dgwitness_angle');
    this.getDic('jz_dgwitness_warn_unit');
    //this.getDic('jz_dgwitness_warnitem');

    this.getRoleList();

    this.getWarnItemTreeData();
  },
  computed: {
    linkangles: {
      get: function () {
        let angles = this.form.linkrolesVos != null ? this.form.linkrolesVos.map(l => l.angleType + '') : [];
        return angles;
      },
      set: function (list) {
        let vos = list.map(l => {
          var item = {angleType: l, flowId: this.form.id};
          return item;
        });
        this.form.linkrolesVos = vos;
      }
    },
    warnItemEditDisable:function () {
        return this.form.warnEnable == 0?true:false
    },


  },
  methods: {
    // 通用审批
    commonBtnHandle(){
        this.dialogType=1
        if(this.form.id){
           this.$nextTick(()=>{
            // this.$refs.flowNodeDialogRef.getProcessFlow(0)
            this.formDialogVisible=true
           })
        }else{
            this.$message.warning("请先保存当前业务流程节点配置信息，再进行审批流配置！")
        }
    },
    specialBtnHandle(){
        this.dialogType=2
        if(this.form.id){
            // this.$refs.flowNodeDialogRef.getCustomList(1)
            // 回显单位科室
            this.sonDataList.forEach((item,index)=>{
               this.$refs.flowNodeDialogRef.setSelectReview(item,index)
            })
            this.formDialogVisible=true
        }else{
            this.$message.warning("请先保存当前业务流程节点配置信息，再进行审批流配置！")
        }
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },

    showWarnItemWindow(id) {

      if(id){
        this.getWarnItemById(id);
      }else{
        const that = this;
        setTimeout(function(){
          that.$refs.warnItemForm.resetFields();
          that.warnItemForm.warnType = ''
        },500)
      }

      if (this.canWarnAdd) {
        this.dialogVisible = true;
      } else {
        this.$message({
          type: 'error',
          message: "请先保存该节点信息!"
        })
      }
    },

    // 保存该节点新增加的预警配置项
    saveWarnItem() {
      const checkNode = this.$refs.cascaderSelectRef.getCheckedNodes(true)
      this.warnItemForm.warnType = checkNode[0].value
      this.$refs['warnItemForm'].validate((valid) => {
        if (valid) {
          this.warnItemForm.notifyRole = this.roleList.toString();
          this.$http.post('/warnItem/saveOrUpdate', this.warnItemForm).then(res => {

            this.backWarn();

            if (res.data.code == 1) {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },


    getDic(type) { // 获取字典
      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_bustype':
              this.businessTypeNamelist = res.data.data;
              break;
            case 'jz_dgwitness_purchaser_mode':
              this.purchaserModeList = res.data.data;
              break;
            case 'jz_dgwitness_warn_compor':
              this.warnComporNamelist = res.data.data;
              break;
            case 'jz_dgwitness_angle':
              this.parterList = res.data.data;
              break;
            case 'jz_dgwitness_warn_unit':
              this.WarnUnitNamelist = res.data.data;
              break;
           /* case 'jz_dgwitness_warnitem':
              this.WarnItemlist = res.data.data;
              break;*/
          }
        }
      })
    },

    getRoleList() { // 获取字典
      this.$http.get('/sys/role/list').then(res => {
        if (res.data.code === '1') {
          this.sysRoleList = res.data.data;
        }
      })
    },
    getCustomList() { // 获取字典
      this.$http.get('/configs/sysFlowNodeConfig/customList?bustype=' + this.form.busType).then(res => {
        if (res.data.code === '1') {
          this.customList = res.data.data;
        }
      })
    },
    getCategoryCodeList() {
      this.$http.get(`/attachment/getAttCagegorys?busType=${this.form.busType}`).then(res => {
        if (res.data.code === '1') {
          this.categoryCodeList = res.data.data;
        }
      })
    },

    backBtn() { //返回
      tabsCloseCurrentHandle();
      this.clearData();
      this.$router.push({
        name: 'flownode_config_list'
      })

    },
    backWarn() { //预警项配置 返回
      this.dialogVisible = false;
      this.$refs.warnItemForm.resetFields();
      this.roleList = [];
    },


    clearData() {
      this.$refs.form.resetFields();
    },
    getDataById() { //详情

      if (this.form.id != "") {

        this.$http.get('/configs/sysFlowNodeConfig/get?id=' + this.form.id).then(res => {
          if (res.data.code == '1') {

            const data = res.data.data;
            this.form = {...data};
            if (typeof(data.purchaserMode)!="undefined") {
              this.form.purchaserMode = data.purchaserMode.split(',')
            }

            this.getCustomList();
            this.getCategoryCodeList()
            this.ChangeHandle(this.form.enableHandle);
          }
        })

      } else {
        //  新增
        this.$refs['form'].resetFields();
        this.form.linkrolesVos = []

      }
    },
    save() { //新增&保存

      this.$refs['form'].validate((valid) => {
        if (valid) {
          //受理：否，则受理角色置空
          if (this.form.enableHandle==0){
            this.form.handleRole=''
          }

          let formParam = JSON.parse(JSON.stringify(this.form))
          formParam.categoryIsOpen = formParam.categoryIsOpen?1:0;
          if (typeof(formParam.purchaserMode)!="undefined") {
            formParam.purchaserMode=formParam.purchaserMode.join(',')
          }
          this.$http.post('/configs/sysFlowNodeConfig/save', formParam).then(res => {
            if (res.data.code == '1') {
              this.canWarnAdd = true;
              this.form.id = res.data.data.id || '';
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              tabsCloseCurrentHandle();
              this.$router.push({
                name: 'flownode_config_view',
                query:{
                  id:this.form.id
                }
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },

   /* selectWarnTypeClick(val) {
      this.warnTypeNamelist.forEach((item, index) => {
        if (item.value == val) {
          this.form.warnTypeName = item.name
        }
      });
    },*/


    selectBusTypeClick(val) {
      this.getCustomList();
      this.getCategoryCodeList();
    },
    selectpurchaserModeClick(val) {

    },


    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
        },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/warnItem/delete', {
          id: item.id
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })
      console.log("ids===>" + ids)

      if (ids != "" || ids.length > 0) {
        this.$http.post('/warnItem/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },


    getDataList() { // 获取列表数据
      console.log("this.form.id==>" + this.form.id);
      if (this.form.id != '') {
        this.$http.post('/warnItem/list', {
          'page': this.pageIndex,
          'rows': this.pageSize,
          //'searchKey': this.form.search,
          // 'filter': this.form
          'filter': {
            flowId: this.form.id
          }
        }).then(res => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable.doLayout()
        })
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },

    getWarnItemById(id) { //根据id获取预警项

      if (id != "") {

        this.$http.get('/warnItem/get?id=' + id).then(res => {
          if (res.data.code == '1') {
            const data = res.data.data
            this.warnItemForm.id = data.id
            this.warnItemForm = data;
            this.warnItemForm.warnType = data.warnType.toString();
            this.warnItemForm.genIsOpen = data.genIsOpen == true?1:0;
            this.warnItemForm.seriIsOpen = data.seriIsOpen == true?1:0;
            this.warnItemForm.genCompor = data.genCompor.toString();
            this.warnItemForm.seriCompor = data.seriCompor.toString();
            let listst = this.warnItemForm.notifyRole;
            this.roleList = listst != null && listst != '' ? listst.split(",") : [];
            this.warnItemForm.mustOpen=data.mustOpen==true?1:0;
          }
        })

      } else {
        //  新增
        this.$refs['warnItemForm'].resetFields();

      }
    },


    updateWarnItem(item) { // 修改该预警项
      var id = item.id;
      this.showWarnItemWindow(id);

    },


    getWarnItemTreeData(){

      this.$http({
        url: `/warnItem/getWarnItemTree`,
        method: 'get'
      }).then(({data}) => {
        if (data) {
          var tree = data.data;
          this.options = tree[0].children;
        } else {
          this.tableData = []
        }
      })
    },

    lazyLoad(node, resolve) {
      let level = node.level;
      let result;

      if(level == 2){

        this.$http({
          url: `/warnItem/listWarnItemBuType?warnType=`+node.data.type,
          method: 'get'
        }).then(({data}) => {
          if (data) {
            result = data.data;
            result.forEach((item) => {
              item.type = item.id;
              item.label = item.itemName;
              item.leaf = true;
            });
            resolve(result);

          } else {
            this.tableData = []
          }

        })

      }else{
        resolve(result);
      }

    },

    setItemList(pageInfo,callback){
      this.$http.get('/sys/dictData/getList?type=jz_dgwitness_warnitem').then(res=>{
       // this.itemList=res.data.rows;
        this.itemList=res.data.data;
        if(callback){
          callback(res.data.total);
        }
      })
    },

    onSelectItemData(val){
      let obj={};
      let filter = this.itemList.filter((item, index) => {
        return item.name == val
      })
      if (filter && filter.length > 0) {
        obj = filter[0];
        this.warnItemForm.itemCode = obj.value
        this.warnItemForm.itemName = obj.name
      } else {
        this.warnItemForm.itemCode = "";
        this.addDetailForm.itemName = "";
      }
    },

    ChangeHandle(val){
      /*console.log(val)*/
      if (val == 1){
        this.showHandleRole=true;
      }else{
        this.showHandleRole=false;
      }
    },




  }
}
</script>

<style lang="less" scoped>
.main_center {
  height: 100%;

  .right-content {
    .set_btn {
      float: right;
      margin-bottom: 20px;
    }

    .more_btn {
      text-align: center;
    }

    .upload-demo {
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;

      .el-button {
        position: absolute;
        right: 0;
      }
    }
    .commonBtn{
        margin-left: 20px;
        margin-right:20px;
    }
  }
}

.el-dialog__body {
  padding-top: 0;

  .dia_top {
    text-align: center;
    margin-top: -3%;
  }

  .dialog_title {
    text-align: right;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    padding: 10px 10px 10px 0;
    border-bottom: none;

    .search_btn {
      margin-left: 20px;
    }
  }
}

.backBtn {
  margin-right: 10%;
}
</style>
